import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';


import { Modal, ModalBody } from 'reactstrap';

import FieldsCodeEditor from '../codeEditor/FieldsCodeEditor';
import * as IFrame from 'react-iframe-form';
import ColorField from '../inputs/colorField';

import EmailComponentLibrary from '../email/emailComponentLibrary';
import FeedbackComponent from '../email/feedbackComponent';
import moment from 'moment';
import { CircularProgressbar } from 'react-circular-progressbar';
import logo from '../../assets/img/logos/simple events logo.png';



let refreshTimeInterval = null;


const ENV =
    process.env.NODE_ENV === 'production'
        ? window.location.href.includes('planner.simple.events') ? `https://admin-api.simple.events/` : `https://beta-api.simple.events/`
        : `http://${window.location.hostname}:5015/`;

class ShareableEmailModule extends Component {
    constructor(props) {
        super(props);
        const { match: { params } } = this.props;

        const customFields = [
            {
                text: 'Organization Name',
                value: '{{orgName}}',
                label: 'Organization Name'
            }
        ];
        this.state = {
            orgSenderEmail: '',
            orgSenderName: '',
            selectedSection: 0,
            editedEmailTemplate: {},
            sendEmailModalOpen: false,
            editing: false,
            errorMessage: false,
            DeleteEmailModalOpen: false,
            loading: true,
            codeExpanded: false,
            previewExpanded: false,
            scheduleEmailModalOpen: false,
            loading: true,
            editCount: 0,
            editedPostData: {},
            designerPanelOpen: false,
            focusedComponent: -1,
            detailsExpanded: false,
            customFields: customFields,

            componentDetailsOpen: false,
            feedbackPanelOpen: false,
            feedbackPanelExpanded: true,
            componentDetailsExpanded: true,
            bodyDetailsOpen: false,
            emailStylesOpen: false,
            newThread: null,
        };
        this.feedbackComponentRef = React.createRef();
    }

    componentDidMount() {
        const { emailTemplate, postData, keyedMetadata, keyedData } = this.props;
        const parameters = emailTemplate.parameters ? [...emailTemplate.parameters] : [];
        keyedMetadata.forEach((option) => {
            !parameters.includes(option) && parameters.push(option);
        })
        const metadataOptions = [];
        keyedData &&
            Object.keys(keyedData).forEach((key) => {
                const layer1 = keyedData[key];
                if (typeof layer1 === 'object') {
                    Object.keys(layer1).forEach((key2) => {
                        const layer2 = layer1[key2];
                        const k2 = key2.substring(0, 1) + key2.substring(1);
                        if (typeof layer2 === 'object') {
                            Object.keys(layer2).forEach((key3) => {
                                const layer3 = layer2[key3];
                                const k3 = key3.substring(0, 1) + key3.substring(1);
                                if (
                                    key !== '_defaultLabel' &&
                                    key2 !== '_defaultLabel' &&
                                    key3 !== '_defaultLabel'
                                ) {
                                    //metadataOptions.push(`${key}.${key2}.${key3}`);
                                    metadataOptions.push({
                                        label: `${layer1._defaultLabel} ${layer2._defaultLabel} ${layer3}`,
                                        value: `{{${key}${k2}${k3}}}`,
                                        text: `${key}${k2}${k3}`
                                    });
                                }
                            });
                        } else {
                            if (key !== '_defaultLabel' && key2 !== '_defaultLabel') {
                                //metadataOptions.push(`${key}.${key2}`);
                                metadataOptions.push({
                                    label: `${layer1._defaultLabel} ${layer2}`,
                                    value: `{{${key}${k2}}}`,
                                    text: `${key}${k2}`
                                });
                            }
                        }
                    });
                } else {
                    if (key !== '_defaultLabel') {
                        metadataOptions.push({ label: layer1, value: key, text: `{{${key}}}` });
                    }
                }
            });
        let codeOnly = (!emailTemplate.emailComponents) || (emailTemplate.emailComponents.length === 0 && emailTemplate.html !== '') || emailTemplate.codeOnly;
        this.setState({ editedEmailTemplate: { ...JSON.parse(JSON.stringify(emailTemplate)), parameters: parameters, codeOnly: codeOnly }, editedPostData: postData, loading: false, customFields: metadataOptions }, () => {
            this.refreshPage();
        });
        window.addEventListener('message', (ev) => {
            if (ev.data.type == 'component-clicked' && this.state.editedEmailTemplate.emailComponents) {
                const componentId = ev.data.componentId;
                if (componentId >= 0) {
                    this.setState({
                        focusedComponent: componentId,
                        componentDetailsOpen: true,
                    });
                }
            }

            if (ev.data.type == 'thread-posted') {
                this.addNewThread(ev.data);
            }
            if (ev.data.type == 'thread-repositioned') {

                const { newThread } = this.state;
                if (newThread) {
                    this.setState({ newThread: { ...newThread, coordinates: ev.data.coordinates } });
                }
            }
            if (ev.data.type == 'comment-badge-clicked') {
                console.log('Tony got clicked', ev.data);
                let threadId = ev.data.threadId;
                this.selectThread(threadId);
            }
            if (typeof ev.data !== 'object') return;
            if (!ev.data.type) return;
            if (ev.data.type !== 'button-click') return;
            if (!ev.data.message) return;
        });
    }

    addNewThread = (pinnedMetadata) => {
        const { feedbackPanelOpen } = this.state;
        const { authenticatedUser } = this.props;

        const newThreadObject = {
            author: { sharedUserId: authenticatedUser._id },
            message: '',
            counter: pinnedMetadata.commentNumber,
            comments: [],
            coordinates: {
                x: pinnedMetadata.clickPosition.x,
                y: pinnedMetadata.clickPosition.y,
            }
        };
        this.setState({ feedbackPanelOpen: true, newThread: newThreadObject });
    }


    updateEditedEmailTemplate = (data, callback) => {
        this.setState({ editing: true, editedEmailTemplate: data }, callback);
    };

    handleNewThreadOnChange = (objChange) => {
        this.setState({ newThread: { ...this.state.newThread, ...objChange } });
    }

    createNewThread = async () => {
        this.props.addNewThread(this.state.newThread, () => {
            this.setState({ newThread: null, editCount: this.state.editCount + 1 });
        });
    }

    deleteThread = (threadId, callback) => {
        this.props.patchThread(threadId, { deleted: true }, () => {
            this.setState({ editCount: this.state.editCount + 1 });
            callback && callback();
        });
    }





    updateEmailComponent = (emailComponents) => {
        this.setState({
            editedEmailTemplate: { ...this.state.editedEmailTemplate, emailComponents: [...emailComponents] },

            editing: true
        }, () => {

            this.focusComponent(this.state.focusedComponent)

        })

    }

    refreshPage = () => {

        if (this.state.editCount > 0) {
            this.setState({ refreshTimeRemaining: 1.5 });
            if (!refreshTimeInterval) {
                refreshTimeInterval = setInterval(() => {
                    if (this.state.refreshTimeRemaining > 0) {
                        this.setState({ refreshTimeRemaining: this.state.refreshTimeRemaining - 0.1 });
                    } else {
                        this.setState({ editCount: this.state.editCount + 1 }, () => { this.focusComponent(this.state.focusedComponent) });
                        clearInterval(refreshTimeInterval);
                        refreshTimeInterval = null;
                    }
                }, 100);
            }

        } else {
            this.setState({ editCount: this.state.editCount + 1 }, () => { this.focusComponent(this.state.focusedComponent) });
        }


    };




    focusComponent = (componentIndex) => {

        const previewFrame = document.getElementsByName(
            'PreviewFrame'
        )[0];


        componentIndex > -1
            ? previewFrame.contentWindow.postMessage(
                {
                    type: 'focusComponent',
                    componentIndex: componentIndex
                },
                '*'
            )
            : previewFrame.contentWindow.postMessage(
                {
                    type: 'unfocus'
                },
                '*'
            );
        this.setState({ focusedComponent: componentIndex, componentDetailsOpen: true, designerPanelOpen: false, emailStylesOpen: false });
    }


    cancelEdit = () => {
        this.setState({
            editedEmailTemplate: this.props.emailTemplate,
            editing: false
        });
    }

    toggleSection = (section) => {
        const { feedbackPanelOpen, componentDetailsOpen } = this.state;
        //this.setState({ editCount: this.state.editCount + 1 });
        switch (section) {
            case 'feedback':
                this.setState({ feedbackPanelOpen: !feedbackPanelOpen, })

                break;
        }
    }

    selectThread = (threadId) => {
        if (this.feedbackComponentRef.current) {
            this.feedbackComponentRef.current.selectThread(threadId);
        }
        // Also open the feedback panel if it's not already open
        this.setState({ feedbackPanelOpen: true });
    }


    render() {
        const { isOpen, toggle, update, url, method, eventId } = this.props;
        const {
            editedEmailTemplate,
            editCount,
            designerPanelOpen,
            focusedComponent,
            detailsExpanded,
            editing,

            componentDetailsOpen,
            feedbackPanelOpen,
            emailStylesOpen,
            componentDetailsExpanded,
            feedbackPanelExpanded,
            bodyDetailsOpen,
            loading,
            codeExpanded
        } = this.state;
        const emailComponents = editedEmailTemplate.emailComponents || [];
        const emailHTML = editedEmailTemplate.html || '';
        const emailStyles = editedEmailTemplate.emailStyles || {};
        let feedbackThreadsMap = [];
        if (this.props.feedbackThreads.length > 0) {
            feedbackThreadsMap = this.props.feedbackThreads.map(thread => {
                return {
                    id: thread._id,
                    counter: thread.counter,
                    coordinates: thread.coordinates
                };
            });
        }
        return (
            <Modal isOpen={isOpen} toggle={toggle} className="fullscreen" >
                <div className='modalHeader ph-20' style={{ borderBottom: '1px solid var(--background)' }}>
                    <div className='headerContainer' style={{ maxWidth: 'unset', minHeight: 60, height: 60 }}>
                        <div className="flex aic  w-100">
                            <div className="navLogo" style={{ width: 'unset' }}>
                                <img src={logo} />
                            </div>
                            <div className='flex ml-20 aic' style={{}}>
                                <div style={{ textAlign: 'center' }}>
                                    <h2>{this.props.event ? this.props.event.name : this.props.program ? this.props.program.name : ''}</h2>
                                    <div className='flex aic '>
                                        <h4>Email</h4> <div className='mr-10 ml-10' style={{ fontSize: 12, lineHeight: 1 }}>|</div>
                                        <h3>{editedEmailTemplate.name}</h3>
                                    </div>
                                </div>
                            </div>
                            {this.state.refreshTimeRemaining > 0 && (
                                <div className='flex aic'
                                    style={{ width: 20, height: 20, fontSize: 20, marginRight: 20 }}
                                >
                                    <CircularProgressbar
                                        value={this.state.refreshTimeRemaining}
                                        maxValue={1.5}
                                        text={this.state.refreshTimeRemaining.toFixed(0)}
                                        strokeWidth={12}
                                        counterClockwise={true}
                                    />
                                </div>
                            )}
                            <button onClick={this.props.closeReport} className='neu ml-a prim'>Logout</button>
                        </div>
                    </div>
                </div>
                <ModalBody className="modalBody">
                    <div className="editorWorkspace">
                        <div className='flex jcsb w-100 h-100'>

                            <div className='designerPreview'>


                                <div className="editorFrame w-100">
                                    <div className='pagePreviewContainer2'>

                                        <IFrame.Form
                                            id="builderPreviewFrame"
                                            key={`template - ${editCount}`}
                                            name="PreviewFrame"
                                            config={{ url, method: 'post', data: { html: editedEmailTemplate.html, rendering: true, style: emailStyles, focusedComponent: this.state.focusedComponent, ...(this.props.eventId ? { eventId: this.props.eventId } : {}), isSharedEmail: true, feedbackThreads: feedbackThreadsMap, codeOnly: editedEmailTemplate.codeOnly, emailId: editedEmailTemplate._id } }}
                                        />

                                    </div>

                                </div>

                                {emailComponents.length == 0 && emailHTML.length === 0 && <div className='startCreatingPrompt'>
                                    <h4>Drag over components from the library to build your email.</h4>
                                </div>}
                            </div>
                            <div style={{ overflowX: 'hidden', position: 'relative' }} className={`designerPanel p-0 right ${emailStylesOpen ? '' : 'closed'}`}>

                                <div style={{ overflowX: 'hidden', padding: 25, paddingBottom: 60, maxHeight: '100%' }} className={`formInputsSection selected`}>
                                    <button onClick={() => this.toggleSection('style')} style={{ padding: 7, marginLeft: -7, marginTop: -7, fontSize: 16 }}><i className='las la-times'></i></button>
                                    <h1 className='mb-15'>Style</h1>
                                    <ColorField useHex={true} label="Background Color" value={emailStyles.backgroundColor} onChange={
                                        (color) => {
                                            const editedEmailTemplate = this.state.editedEmailTemplate;
                                            const emailStyles = editedEmailTemplate.emailStyles || {};
                                            emailStyles.backgroundColor = typeof color == 'object' ? '' : color;
                                            editedEmailTemplate.emailStyles = emailStyles;
                                            this.setState({ editedEmailTemplate, editing: true, editCount: this.state.editCount + 1 });
                                        }
                                    } />
                                </div>
                            </div>
                            <div style={{ overflowX: 'hidden', position: 'relative' }} className={`designerPanel p-0 right ${feedbackPanelOpen ? '' : 'closed'} ${feedbackPanelExpanded ? 'expanded' : ''}`}>
                                <div style={{ overflowX: 'hidden', overflowY: 'auto', padding: 25, paddingBottom: 60, height: 'calc(100vh - 120px)' }} className={`formInputsSection selected`}>
                                    <button onClick={() => this.toggleSection('feedback')} style={{ padding: 7, marginLeft: -7, marginTop: -7, fontSize: 16 }}><i className='las la-times'></i></button>

                                    {!loading &&
                                        <FeedbackComponent
                                            ref={this.feedbackComponentRef}
                                            componentSelected={focusedComponent !== -1 ? true : false}
                                            editedEmailTemplate={editedEmailTemplate}
                                            focusedComponentIndex={focusedComponent}
                                            togglePanel={() => { this.setState({ componentDetailsOpen: !componentDetailsOpen }) }}
                                            expanded={componentDetailsExpanded}
                                            expandPanel={() => this.setState({ componentDetailsExpanded: !componentDetailsExpanded })}
                                            focusComponent={this.focusComponent}
                                            updateEmailComponent={this.updateEmailComponent}
                                            links={this.props.links}
                                            staticCustomFields={this.props.staticCustomFields}
                                            customFields={this.state.customFields}
                                            newThread={this.state.newThread}
                                            handleNewThreadOnChange={this.handleNewThreadOnChange}
                                            createNewThread={this.createNewThread}
                                            feedbackThreads={this.props.feedbackThreads}
                                            patchThread={this.props.patchThread}
                                            deleteThread={this.deleteThread}
                                            authenticatedUser={this.props.authenticatedUser}
                                        />}
                                </div>
                            </div>

                            {<div className='designerPanel side p-0' style={{ overflow: 'hidden', position: 'relative', minWidth: 100, width: 100 }} >
                                <div className='flex column jcc'>
                                    <div className={`flex column jcc aic c - pointer ${feedbackPanelOpen ? 'selectedSection' : ''} `} style={{ height: 100, position: 'relative' }} onClick={() => {
                                        this.toggleSection('feedback')
                                    }}>
                                        <i className='las la-comments mb-10' style={{ fontSize: 30 }}></i>
                                        <h5>Feedback</h5>
                                        {(() => {
                                            const openThreadsCount = this.props.feedbackThreads.filter(thread => !thread.deleted && (!thread.status || thread.status === 'open')).length;
                                            return openThreadsCount > 0 ? (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: 10,
                                                    right: 20,
                                                    backgroundColor: '#FF586B',
                                                    color: 'white',
                                                    borderRadius: '50%',
                                                    width: 25,
                                                    height: 25,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: 12,
                                                    fontWeight: 'bold',
                                                    border: '2px solid white'
                                                }}>
                                                    {openThreadsCount}
                                                </div>
                                            ) : null;
                                        })()}
                                    </div>

                                </div>


                            </div>}
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

export default withRouter(ShareableEmailModule);
